<tt-page class="col-xs-12 col-md-6 sp-0">
    <tt-card>
        <tt-button-goto [ttText]="'product_pic_create_new'" (ttClick)="goToFunc('productpic')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListProductPictures"></tt-list>
</tt-page>
